import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskCmdbAssetsObjectSchemaConfigurationRoute: InvariantJiraRoute = {
	name: 'servicedesk-cmdb-object-schema-configuration',
	path: '/jira/servicedesk/assets/configure/object-schema/:objectSchemaId',
};
